//Bootstrap column size /12
export const LABEL_SIZE = 4; //label width at bootstrap md setting
export const INPUT_SIZE = 12 - LABEL_SIZE;
//page margin
export const MARGIN = 2; //side margin at bootstrap lg setting
export const WIDTH = 12 - MARGIN * 2;
